import type { Product, SourceProduct } from "./types";

function hashText(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) % 997;
  }
  return hash;
}

function toGrade(seed: number): number {
  const grade = 1 + (seed / 997) * 3.2;
  return Number(grade.toFixed(1));
}

export function deriveRatings(item: SourceProduct): Pick<Product, "overall" | "handling" | "safety"> {
  const base = hashText(`${item.brand} ${item.model}`);
  const priceSeed = Math.round(item.price.amount) % 997;

  const handling = toGrade((base + priceSeed) % 997);
  const safety = toGrade((base * 2 + (item.isAvailable ? 127 : 331)) % 997);
  const overall = Number((((handling + safety) / 2) * 0.95).toFixed(1));

  return {
    overall,
    handling,
    safety
  };
}
